export enum InputTypeConfigType {
  TEXT_AREA = 'textarea',
  TEXT_BOX = 'textbox',
  EMAIL = 'email',
  PHONE = 'phone',
  WEBSITE = 'website',
  NUMBER = 'number',
  DECIMAL = 'decimal',
  DATE = 'date',
  DATE_TIME = 'datetime',
}

export enum DropdownRenderTypeConfig {
  RADIO_GROUP = 'radio_group',
  REMOTE_SEARCHABLE = 'remote_searchable',
}
export interface DataTypeConfigType {
  decimalScale?: number;
  inputTypeConfig?: InputTypeConfigType;
  dropdownRenderType?: DropdownRenderTypeConfig;
  maxTextLength?: number;
  pastTimeNotAllowed?: boolean;
  uiIconName?: string;
}

export interface AssociableType {
  id: string;
  attributeName: string;
  schemaName: string;
  dataType: string;
  dataTypeConfig?: DataTypeConfigType;
  isMandatory: boolean;
}
